import { Box, Image, Text } from '@wix/design-system';
import React from 'react';
import { TRIGGER_ICON_SIZE } from '../../constants';
export const AutomationTrigger = _ref => {
  let {
    appName,
    triggerName,
    iconUrl
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "9px",
    verticalAlign: "middle",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(Image, {
    transparent: true,
    src: iconUrl,
    width: TRIGGER_ICON_SIZE,
    height: TRIGGER_ICON_SIZE,
    borderRadius: 2
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    verticalAlign: "middle"
  }, !!appName && /*#__PURE__*/React.createElement(Box, {
    minHeight: 18,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    ellipsis: true
  }, appName)), /*#__PURE__*/React.createElement(Box, {
    minHeight: 18,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    ellipsis: true
  }, triggerName))));
};
//# sourceMappingURL=AutomationTrigger.js.map